import { getElement, getElements } from "./utils/getElement";

const initDrawLines = () => {

  if (window.matchMedia('(max-width: 992px)').matches) {
    return;
  }

  const markers = getElements('.js-case-marker');

  markers.forEach((marker) => {
    const index = marker.classList.value.indexOf('js-case-marker-');
    if (index === -1) return;

    const partId = marker.classList.value.slice(index + 15);
    const casePart = getElement(`[data-part-id="${partId}"] .js-marker-start`);
    const partCard = document.querySelector(`[data-part-id="${partId}"].js-case-part-card`)?.closest('.c-card--pc-part');
    const markerImg = marker.querySelector('img');

    if (!casePart || !markerImg || !partCard) return;

    // Create the line once (hidden initially)
    const line = new LeaderLine(casePart, markerImg, {
      startPlug: 'behind',
      endPlug: 'behind',
      color: '#FC4E02',
      size: 3,
      path: 'fluid',
      startSocket: 'auto',
      endSocket: 'auto',
      hide: true, // hide initially
      dash: false,
    });

    // Function to show line + activate elements
    function showLine() {
      line.show('fade', { duration: 200 });
      casePart.classList.add('is-active');
      partCard.classList.add('is-active');
      marker.classList.add('is-active');
    }

    // Function to hide line + deactivate elements
    function hideLine() {
      line.hide('fade', { duration: 120 });
      casePart.classList.remove('is-active');
      partCard.classList.remove('is-active');
      marker.classList.remove('is-active');
    }

    if (window.matchMedia("(min-width: 992px)").matches) {
      // --- Hover events ---
      marker.addEventListener('mouseenter', showLine);
      marker.addEventListener('mouseleave', hideLine);

      casePart.addEventListener('mouseenter', showLine);
      casePart.addEventListener('mouseleave', hideLine);

      partCard.addEventListener('mouseenter', showLine);
      partCard.addEventListener('mouseleave', hideLine);

      // --- Click toggle ---
      marker.addEventListener('click', () => {
        if (line.visible()) hideLine();
        else showLine();
      });
      casePart.addEventListener('click', () => {
        if (line.visible()) hideLine();
        else showLine();
      });
      partCard.addEventListener('click', () => {
        if (line.visible()) hideLine();
        else showLine();
      });

      // --- Keep position updated ---
      window.addEventListener('scroll', () => line.position());
      window.addEventListener('resize', () => line.position());
    }
  });
};

export { initDrawLines };